<script>
  /* eslint-disable no-console */
  import { textToId } from "$lib/utilities/dom-helpers";

  export let idOverride = "";
  export let text;
  let clazz = "";
  export { clazz as class };

  const id = idOverride || textToId(text);
  const classes = `focus:underline ${clazz} block`;
</script>

<!-- This element is replaced entirely on render  -->
<span data-heading data-testid="heading" class={classes} {id} {...$$restProps}>
  {text}
</span>
